import VImg from './VImg';
export { VImg };
export default VImg;
//# sourceMappingURL=index.js.map